// ── Nacherfassung: lock polling ─────────────────────────────────────────────
// Marks result rows currently locked by another session (class is_locked).
// The module renders the dispatcher URL on the result table as
// data-regcompl-lock-url; the own session ticket comes from
// window.DIMEDIS.session (set in <head> by the shell).
(function () {
    'use strict';

    if (!document.querySelector('tr.result_row')) return;

    var ownTicket = (window.DIMEDIS && window.DIMEDIS.session && window.DIMEDIS.session.ticket) || '';
    var lastCheck = 0;

    function markLockedRows(lockList) {
        document.querySelectorAll('tr.result_row').forEach(function (row) {
            row.classList.remove('is_locked');
        });
        lockList.forEach(function (entry) {
            // Own edits are not locked out.
            if (ownTicket && entry.ticket === ownTicket) return;
            // A locked record may not be on the current result page.
            var row = document.getElementById('result_row_' + entry.lock_id);
            if (row) row.classList.add('is_locked');
        });
    }

    // Legacy-compat: the unpatched module ships its own inline polling
    // script (plain JS, it still runs) whose marker function throws when a
    // locked record is not on the current result page. Overwrite it with
    // the null-safe version above; the legacy poller keeps calling it.
    window.reg_completion_mark_currently_locked_regis = markLockedRows;

    // Without the data attribute the legacy inline script does the polling
    // itself — only the marker override above applies.
    var table = document.querySelector('[data-regcompl-lock-url]');
    if (!table) return;

    var lockUrl = table.getAttribute('data-regcompl-lock-url');

    function checkCurrentLocks() {
        if (document.hidden) return; // paused while the tab is not visible
        if (Date.now() - lastCheck < 5000) return; // throttle
        lastCheck = Date.now();

        fetch(lockUrl, { credentials: 'same-origin' })
            .then(function (res) {
                if (!res.ok) throw new Error('HTTP ' + res.status);
                return res.json();
            })
            .then(markLockedRows)
            .catch(function (err) {
                if (window.regCompletionDebug) console.warn('[regcompl-locks] poll failed:', err);
            });
    }

    checkCurrentLocks();
    var intervalId = setInterval(checkCurrentLocks, 10000);

    document.addEventListener('visibilitychange', function () {
        if (!document.hidden) checkCurrentLocks();
    });
    window.addEventListener('pagehide', function () {
        clearInterval(intervalId);
    });
})();
